module.exports = __webpack_public_path__ + "static/media/insta.41ece4a9.svg";